import * as React from "react";
import { Conductor } from "@models/conductor";
import { Button, Divider, Modal, Table, Avatar } from "antd";
import { FormattedMessage, FormattedTime, injectIntl, intlShape } from "react-intl";
import Message from "@constants/message";
import { NavLink } from "react-router-dom";
import { PaginationDefaultParams } from "@components/custom/Paginator";
import FormattedDateTime from "@components/custom/FormattedDateTime";

type Props = {
  data: Conductor[];
  loading: boolean;
  deleteFn: (item: Conductor) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const SuppliersPaymentsTable: React.FC<Props> = props => {
  const { data, loading, currentPage, footer } = props;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`} />,
      width: 30,
      dataIndex: "index",
      key: "id",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: <FormattedMessage id="app.amount" defaultMessage={`Amount`} />,
      width: 150,
      align:"right",
      dataIndex: "amount",
      key: "amount"
    },
    {
      title: <FormattedMessage id="app.description" defaultMessage={`description`} />,
      dataIndex: "description",
      key: "description"
    },
    {
      title: (
        <FormattedMessage
          id="app.payment_at"
          defaultMessage={`payment_at`}
        />
      ),
      width: 150,
      dataIndex: "payment_at",
      key: "payment_at",
      render: (payment_at, record) => <FormattedDateTime date={payment_at} />
    },
    {
      title: "",
      key: "actions",
      width: 90,
      dataIndex: "actions",
      render: (text, record) => (
        <NavLink to={`/suppliers/${record.supplier.id}/payments/${record.id}/edit`}>
          <Button type="link" size={`small`}>
            <FormattedMessage id="app.edit" defaultMessage={`Edit`} />
          </Button>
        </NavLink>
      )
    }
  ];

  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
      footer={footer}
    />
  );
};

export default injectIntl(SuppliersPaymentsTable);
